<template>
  <el-select
    v-model="userId"
    ref="adminUserRef"
    :loading="isLoading"
    size="small"
    :clearable="clearable"
    @clear="onClear"
    :disabled="disable"
    filterable
    remote
    :remote-method="getList"
    placeholder="请选择"
  >
    <el-option
      v-for="item in list"
      :label="item.userName"
      :value="item.id"
      :key="item.id"
    />
  </el-select>
</template>

<script>
import { getUserListAPI } from './api.js';

export default {
  name: 'SelectAdminUser',

  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    jobCode: {
      type: String,
      default: '',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disable: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    userId: {
      get() {
        return this.value > 0 ? this.value : undefined;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },

  data() {
    return {
      list: [],
      isLoading: false,
    }
  },

  created() {
    this.getList('');
  },

  methods: {
    async getList(userName) {
      let params = {
        userName: userName,
        jobCode: this.jobCode,
      };
      this.list = await getUserListAPI(params);
    },

    close() {
      this.getList('');
      this.$refs.adminUserRef.blur();
    },

    onClear() {
      this.getList('');
      this.$refs.adminUserRef.blur();
    },
  }
}
</script>
